/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSpaceRequest } from '../../models/create-space-request';
import { CreateSpaceResult } from '../../models/create-space-result';

export interface ApiSpacesPost$Params {
      body?: CreateSpaceRequest
}

export function apiSpacesPost(http: HttpClient, rootUrl: string, params?: ApiSpacesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSpaceResult>> {
  const rb = new RequestBuilder(rootUrl, apiSpacesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSpaceResult>;
    })
  );
}

apiSpacesPost.PATH = '/api/Spaces';
